import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';

const StyledButton = styled.div`
  font-size: 1.405vw;
  transition: 0.4s;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3.436vw;
  border-radius: 1.718vw;
  color: #FFF;
  background-color: ${(props) => props.theme.blueColorPrimary};
  &:hover {
    &:not(:disabled) {
      cursor: pointer;
      background-color: ${(props) => props.theme.blueColorPrimaryHover};
    }
  }
`;
const CartButton = (props) => {
  const { theme, darkThemeSelected } = useContext(ThemeContext);
  const { size, deActive } = props;
  return (
    <StyledButton
      theme={theme}
      size={size}
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
    >
      {props.text}
    </StyledButton>
  );
};

export default CartButton;
